import { Link } from 'react-router-dom';
import { articleTeaserContent } from '@/mocks/content';

export default function ArticleTeaser() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6 lg:px-10 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="w-full lg:w-[42%] flex flex-col items-start">
            <span className="inline-flex items-center px-3.5 py-1.5 rounded-full border border-foreground-200/50 text-xs font-semibold text-foreground-500 tracking-wide mb-6">
              {articleTeaserContent.label}
            </span>
            <div className="aspect-[4/3] w-full rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20workspace%20with%20laptop%20displaying%20product%20catalog%20spreadsheet%20on%20wooden%20desk%2C%20coffee%20cup%20and%20notebook%2C%20soft%20natural%20daylight%20from%20window%2C%20cream%20beige%20interior%2C%20modern%20clean%20editorial%20photography&width=800&height=600&seq=teaser-v2-main&orientation=landscape"
                alt="Guida Itaobuy Spreadsheet"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          <div className="w-full lg:w-[58%] lg:pl-4">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-[1.12] mb-5">
              {articleTeaserContent.titleFirst}
              <br />
              {articleTeaserContent.titleSecond}{' '}
              <span className="font-normal italic">{articleTeaserContent.titleThird}</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mb-8">
              {articleTeaserContent.description}
            </p>
            <Link
              to="/articolo/guida-completa-itaobuy-spreadsheet"
              className="inline-flex items-center gap-2.5 px-7 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-all duration-300"
            >
              {articleTeaserContent.button}
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}